import { render, staticRenderFns } from "./dashboard-layout.vue?vue&type=template&id=0999d4ed&scoped=true"
import script from "./dashboard-layout.vue?vue&type=script&lang=js"
export * from "./dashboard-layout.vue?vue&type=script&lang=js"
import style0 from "./dashboard-layout.vue?vue&type=style&index=0&id=0999d4ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0999d4ed",
  null
  
)

export default component.exports